import { client } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = () => client.otpEvents.getAll();
